import React, { useEffect } from 'react';
import { useTable, usePagination, useSortBy } from 'react-table';
import {
  Cell,
  Container,
  Wrapper,
  Table,
  TR,
  TH,
  TBody,
  TD,
  THead,
  TREmpty,
  VR,
} from './style';
import Pagination from './Pagination';
import Spinner from 'components/Spinner';

export default React.memo(
  ({
    data = [],
    reportsData = [],
    headers,
    height,
    notCheckable,
    onChange,
    total,
    page,
    id,
  }) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      prepareRow,
      rows,
      canPreviousPage,
      canNextPage,
      pageCount,
      gotoPage,
      nextPage,
      previousPage,
      setPageSize,
      state: { pageIndex, pageSize, sortBy },
    } = useTable(
      {
        columns: headers,
        data,
        manualSortBy: true,
        autoResetPage: false,
        autoResetSortBy: false,
        initialState: {
          pageIndex: 0,
          pageSize: 10,
        },
        manualPagination: true,
        pageCount: page,
      },
      useSortBy,
      usePagination
    );

    useEffect(() => {
      if (onChange) {
        onChange(reportsData, { pageIndex, pageSize });
      }

      let result = reportsData;
      if (sortBy[0]?.desc) {
        switch (sortBy[0]?.id) {
          case 4:
            result = result?.sort(
              (a, b) => b?.lateTime?.minute - a?.lateTime?.minute
            );
            break;
          case 1:
            result = result?.sort(function (a, b) {
              if (a.user_name < b.user_name) {
                return -1;
              }
              if (a.user_name > b.user_name) {
                return 1;
              }
              return 0;
            });
            break;
        }

        onChange(result, { pageIndex, pageSize });
      }
      if (!sortBy[0]?.desc) {
        switch (sortBy[0]?.id) {
          case 4:
            result = result?.sort(
              (a, b) => a?.lateTime?.minute - b?.lateTime?.minute
            );
            break;
          case 1:
            result = result?.sort(function (a, b) {
              if (a.user_name < b.user_name) {
                return -1;
              }
              if (a.user_name > b.user_name) {
                return 1;
              }
              return 0;
            }).reverse();
            break;
        }
        onChange(result, { pageIndex, pageSize });
      }
    }, [onChange, pageIndex, pageSize, sortBy]);

    if (data.length === 0)
      return (
        <h2 style={{ textAlign: 'center', fontSize: '26px', color: '#a8a8a8' }}>
          Натижалар аниқланмади!
        </h2>
      );
    return (
      <Container>
        <Wrapper
          height={height}
          vertical={false}
          ignoreElements='input, .content>span'
        >
          <>
            <Table {...getTableProps()} id={id}>
              <THead>
                {headerGroups.map((headerGroup, idx) => (
                  <TR
                    {...headerGroup.getHeaderGroupProps()}
                    notCheckable={notCheckable}
                    key={`${idx + 1}`}
                  >
                    {headerGroup.headers.map((header, index) => (
                      <TH
                        key={`${index + 1}`}
                        {...header.getHeaderProps(
                          header.getSortByToggleProps()
                        )}
                      >
                        <Cell {...header}>
                          {header.render('Header')}{' '}
                          <span>
                            {header.sort && header.isSorted
                              ? header.isSortedDesc
                                ? ' 🔽'
                                : ' 🔼'
                              : ''}
                          </span>
                        </Cell>
                      </TH>
                    ))}
                  </TR>
                ))}
              </THead>
              <TBody {...getTableBodyProps()}>
                {rows.map((row, index) => {
                  prepareRow(row);
                  return (
                    <React.Fragment key={`${index + 1}`}>
                      <TREmpty />
                      <TR>
                        {row.cells.map((cell, ind) => {
                          const { column } = cell;
                          return (
                            <TD key={`${ind + 1}`} {...column}>
                              <Cell {...column}>
                                <VR />
                                {cell.render('Cell')}
                              </Cell>
                            </TD>
                          );
                        })}
                      </TR>
                    </React.Fragment>
                  );
                })}
              </TBody>
            </Table>
          </>
        </Wrapper>
        {total > 10 ? (
          <Pagination
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            gotoPage={gotoPage}
            nextPage={nextPage}
            pageIndex={pageIndex}
            previousPage={previousPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            pageCount={pageCount}
          />
        ) : null}
      </Container>
    );
  }
);
